module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back-top display-none",
    on: {
      "click": function($event) {
        return _vm.backTop()
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-jiantou-copy-copy"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1207840f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/backTop.vue
// module id = 28
// module chunks = 7 8 9 10